import { useEffect, useState, useRef } from "react";
import styles from "./styles.module.css";
import { Button, Table, Spin, Row, Col } from "antd";
import { ModalComponent } from "../../components/ModalComponent";
import { setOpenInfo } from "../../store/user";
import { InfoModal } from "../../components/InfoModal";
import { useDispatch, useSelector } from "react-redux";
import { clearErrorStudio } from "../../store/studios";
import { getStudioData } from "../../store/studios/selectors";
import { getOpenInfoSelector } from "../../store/user/selectors";
import {
  getAwardSchemes,
  deleteAwardSchemes,
  clearError,
  clearSuccessDelete,
} from "../../store/awardSchemes";
import {
  getError,
  getAwardSchemesData,
  getSuccessDelete,
  getSuccessEdit,
  getSuccessCreate,
  getAwardSchemesLoading,
  getOpenAwardSchemesCreateSelector,
  getAwardSchemesNextPage,
} from "../../store/awardSchemes/selectors";
import displayErrors from "../../utils/displayErrors";
import { CreateAwardSchemesModal } from "../../components/CreateAwardSchemesModal";
import { EditAwardSchemesModal } from "../../components/EditAwardSchemesModal";
import { columns } from "./utils";

export const AwardSchemesPage = () => {
  const dispatch = useDispatch();
  const studioData = useSelector(getStudioData);
  const error = useSelector(getError);
  const awardSchemesData = useSelector(getAwardSchemesData);
  const [width, setWidth] = useState(window.innerWidth);
  const isLoading = useSelector(getAwardSchemesLoading);
  const successCreate = useSelector(getSuccessCreate);
  const successEdit = useSelector(getSuccessEdit);
  const successDelete = useSelector(getSuccessDelete);
  const openAwardSchemesCreate = useSelector(getOpenAwardSchemesCreateSelector);
  const openInfo = useSelector(getOpenInfoSelector);
  const [openAwardSchemesDelete, setOpenAwardSchemesDelete] = useState(false);
  const [openAwardSchemesEdit, setOpenAwardSchemesEdit] = useState(false);
  const [needToLoad, setNeedToLoad] = useState(false);
  const nextPage = useSelector(getAwardSchemesNextPage);
  const lastItem = useRef();
  const observer = useRef();

  const fetchData = (pagination = false) => {
    dispatch(
      getAwardSchemes({
        studio_y_id:
          JSON.parse(sessionStorage.getItem("studio"))?.y_id ||
          studioData?.y_id,
        pagination: pagination,
      })
    );
  };

  useEffect(() => {
    dispatch(clearErrorStudio());
    dispatch(clearError());
  }, []);

  useEffect(() => {
    (async () => {
      if (needToLoad && nextPage) {
        fetchData(true);
        setNeedToLoad(false);
      }
    })();
  }, [needToLoad]);

  useEffect(() => {
    if (studioData) {
      const timerRefresh = setTimeout(fetchData, 0);
      return () => {
        clearTimeout(timerRefresh);
      };
    }
  }, [studioData, successCreate, successDelete, successEdit]);

  useEffect(() => {
    if (isLoading) return;

    if (observer?.current) observer?.current.disconnect();

    let callback = function (
      entries
      //observer
    ) {
      if (
        entries[0].isIntersecting &&
        nextPage &&
        awardSchemesData?.data?.results?.length > 0
      ) {
        setNeedToLoad(true);
      }
    };
    observer.current = new IntersectionObserver(callback);
    if (lastItem?.current instanceof Element) {
      observer.current.observe(lastItem.current);
    }
  }, [isLoading]);

  useEffect(() => {
    window.addEventListener("resize", () => {
      setWidth(window.innerWidth);
    });
  }, [width]);

  return (
    <>
      <div
        style={{
          marginBottom: 10,
          fontSize: 12,
          fontWeight: 300,
          marginLeft: 5,
        }}
      >
        Показано {awardSchemesData?.data?.results?.length || 0} из{" "}
        {awardSchemesData?.data?.count || 0}
      </div>
      <div
        style={{
          maxHeight: "calc(100vh - 200px)",
          width: "60%",
          overflowY: "auto",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {error && displayErrors(error)}
        <Table
          columns={columns({ setOpenAwardSchemesDelete })}
          rowKey={(obj) => obj.id}
          size="small"
          pagination={false}
          loading={isLoading && <Spin size="large" />}
          className={`${styles.table} ${styles.table_header}`}
          dataSource={awardSchemesData?.data?.results || []}
          onRow={(record) => ({
            onClick: () => {
              setOpenAwardSchemesEdit({
                open: true,
                record: record,
              });
            },
          })}
        />
        <div ref={lastItem} style={{ minHeight: 10, maxHeight: 10 }} />
      </div>
      {openAwardSchemesCreate && (
        <CreateAwardSchemesModal openTypeCreate={openAwardSchemesCreate} />
      )}
      {openAwardSchemesEdit?.open && (
        <EditAwardSchemesModal
          openAwardSchemesEdit={openAwardSchemesEdit}
          setOpenAwardSchemesEdit={setOpenAwardSchemesEdit}
        />
      )}
      {openAwardSchemesDelete?.open && (
        <ModalComponent
          open={openAwardSchemesDelete.open}
          title={`Вы уверены, что хотите удалить эту схему премии "${openAwardSchemesDelete?.data?.scheme?.name}"?`}
          body={
            <>
              {error && displayErrors(error)}
              <Row gutter={20}>
                <Col span={12}>
                  <Button
                    style={{
                      width: "100%",
                      borderRadius: 4,
                      height: 48,
                    }}
                    onClick={() => setOpenAwardSchemesDelete(false)}
                  >
                    Не удалять
                  </Button>
                </Col>
                <Col span={12}>
                  <Button
                    style={{
                      width: "100%",
                      borderRadius: 4,
                      height: 48,
                      background: "var(--Primary-1-normal, #76CEC9)",
                    }}
                    type="primary"
                    htmlType="submit"
                    onClick={() => {
                      dispatch(
                        deleteAwardSchemes({
                          studio_y_id: studioData?.y_id,
                          id: openAwardSchemesDelete.data.id,
                        })
                      ).then((state) => {
                        if (!state?.payload?.errors) {
                          dispatch(clearSuccessDelete());
                          setOpenAwardSchemesDelete(false);
                        }
                      });
                    }}
                  >
                    Удалить
                  </Button>
                </Col>
              </Row>
            </>
          }
          onCancel={() => {
            setOpenAwardSchemesDelete(false);
          }}
        />
      )}
      {openInfo && (
        <InfoModal
          openModal={openInfo}
          setOpenModal={setOpenInfo}
          title={"Информация о схеме премий"}
          text={"Тут будет информация"}
        />
      )}
    </>
  );
};
